module.exports = __webpack_public_path__ + "img/iconYouNew.b20b570d.png";